import React from 'react';
import MedicationIcon from "../MedicationIcon";
import { AIChatInput } from "../entry-methods/ai-chat/AIChatInput"; 
import { ImportInput } from "../entry-methods/import/ImportInput";
import { Button } from "@/components/ui/button";

// Configuration for all medication input methods
export const inputMethodsConfig = [
  {
    id: "import",
    title: "Import from health records",
    description: "Connect your EHR to import medications automatically",
    icon: <MedicationIcon type="health" className="text-white" />,
    iconBgColor: "bg-blue-500",
    buttonText: "Connect Health Records",
    component: ({ recordMethodUsage, toast, toggleSection }) => (
      <ImportInput 
        onProcessed={(result) => {
          recordMethodUsage("import");
          toast({
            title: "Medications imported",
            description: `Successfully imported ${result.length} medications`,
          });
          toggleSection(null);
        }} 
      />
    )
  },

  {
    id: "freeform",
    title: "Chat with AI Assistant",
    description: "Let our AI help you add medications through conversational chat",
    icon: <MedicationIcon type="freeform" className="text-white" />,
    iconBgColor: "bg-blue-400",
    buttonText: "Start Chat",
    component: ({ recordMethodUsage, toast, toggleSection }) => (
      <AIChatInput 
        onProcessed={(result) => {
          recordMethodUsage("freeform");
          toast({
            title: "Medication added",
            description: `Successfully added ${result.name}`,
          });
          toggleSection(null);
        }} 
      />
    )
  }
];